module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10048.53d8ccdf.jpg";